import { RouterModule, Routes } from '@angular/router';
import { LbgLandingPage } from './lbg-landing-page';

const routes: Routes = [{ path: 'welcome', component: LbgLandingPage }];

export const LbgSharedRouting = RouterModule.forChild(routes);
